import React from 'react';
import styles from './tail.module.css'
import '../../App.css'

class Tail extends React.Component {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles.tailText}>Copyright ©2022 | 朗宾公司版权所有</div>
                <div className={styles.tailText}><a className={styles.tailAText} href="https://beian.miit.gov.cn" target="_blank">浙ICP备2024086111号-1</a>&nbsp;| 浙公网安备33010602011233 | 经营许可证号 浙B2-20210400</div>
            </div>
        );
    }
}

export default Tail;
